<template>
    <div id="searchSyntenicGenefunction">
        <div id="function">
            <div style="margin-left:578px;margin-top: 1px;">
               <img src="../assets/img/close.png" style="width: 24px;height: 18px" @click.self="hideSelf" title="close">
            </div>
            <h2 style="text-align: center;margin: 10px auto;color: #275015">Search {{target}} in</h2>
            <hr style="color: #276914;margin-bottom: 8px">
            <div class="subfunction" >
                <button @click="btn_user($event)" class="function_button">Annotations</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">JBrowse</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">Syntenic gene</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">Nonsyntenic orth</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">Flanking Primer</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">Flanking region</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">Gene sequence</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">MicroSynteny</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">Coge</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">Transcriptome</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">Polymorph</button>
            </div>
            <div class="subfunction">
                <button @click="btn_user($event)" class="function_button">AthBestHit</button>
            </div>
        </div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "SyntenicGeneFunctionSelection",
        props: ["target"],
        data() {
            return {
                subFunction: '',
                geneID: '',
            }
        },
        mounted() {
            // console.log(this.target);
        },
        methods: {
            btn_user (e) {
                // console.log(e.target.innerHTML)
                this.subFunction = e.target.innerHTML;
                this.geneID = this.target;
                this.$emit("watchSubFunction", this.subFunction, this.geneID, this)
            },
            hideSelf() {
                this.$emit("hideBox");
            },

        },
    }
</script>

<style>
    #searchSyntenicGenefunction {
        position: fixed;
        width: 600px;
        /* height: 230px; */
        background: #77B07F;
        left: 0;
        right: 0;
        top: 25%;
        margin: 0 auto;
    }

    #searchSyntenicGenefunction #function .subfunction {
        float: left;
        text-align: center;
        width: 300px;
        height: 30px;
        margin-top: 5px;
    }

    #searchSyntenicGenefunction #function .subfunction .function_button {
        margin: auto;
        font-size: 20px;
        color: #ffffff;
        background: #77B07F;
        border: 0px;
    }

    #searchSyntenicGenefunction #function .subfunction .unfunction_button {
        margin: auto;
        font-size: 20px;
        color: #C0C0C0;
        background: #77B07F;
        border: 0px;
    }

    #searchSyntenicGenefunction #function .subfunction .function_button:hover {
        /*margin: auto;*/
        /*font-size: 20px;*/
        color: #333a61;
        /*background: #77B07F;*/
        /*border: 0px;*/
    }

    #searchSyntenicGenefunction #function .subfunction_wide {
        float: left;
        text-align: center;
        width: 600px;
        height: 30px;
        margin-top: 5px;
    }

    #searchSyntenicGenefunction #function .subfunction_wide .function_button {
        margin: auto;
        font-size: 20px;
        color: #ffffff;
        background: #77B07F;
        border: 0px;
    }

    #searchSyntenicGenefunction #function .subfunction_wide .unfunction_button {
        margin: auto;
        font-size: 20px;
        color: #C0C0C0;
        background: #77B07F;
        border: 0px;
    }

    #searchSyntenicGenefunction #function .subfunction_wide .function_button:hover {
        /*margin: auto;*/
        /*font-size: 20px;*/
        color: #333a61;
        /*background: #77B07F;*/
        /*border: 0px;*/
    }
    
</style>